import styled, { css } from "styled-components";
import tw from "twin.macro";


export const UTextarea = styled.textarea(() => [
  tw`w-full h-full resize-none outline-1 pr-[0.2rem] outline-pink-400`,
  css`
    &::-webkit-scrollbar {
      background: transparent;
      width: 0.2rem;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 1rem;
      ${tw`bg-pink-400`}
    }
  `,
]);

export const USaveButton = styled.button(() => [
  tw`px-1 py-0.5 text-white bg-pink-400 !opacity-100 rounded-3xl`,
]);
export const UCancelButton = styled.button(() => [
  tw`px-1 border-2 border-pink-400 py-0.5 text-pink-400 !opacity-100 rounded-3xl`,
]);